import React, { Component } from 'react';
import { Descriptions, Form, Input, Button, Tabs, Table, Select, Pagination, notification, DatePicker } from 'antd';
import { SearchOutlined, CloudDownloadOutlined } from '@ant-design/icons'
import { post, downloadFile } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';
import ValidPassword from './ValidPassword';
import moment from 'moment';
import PropTypes from 'prop-types';

const { TabPane } = Tabs;

let privilege;

const isSMRTNonCFOUser = sessionManager.getIsSMRTNonCFOUser();

let columns = [
    {
        dataIndex: 'transactionTime',
        title: 'Date and Time',
        width: 80,
        render: text => {
            return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss");
        }
    }, {
        dataIndex: 'destinationAccountOwnerName',
        title: 'Area Name',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'destinationAccountName',
        title: 'Outlet Name',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'destinationAccountAlias',
        title: 'Counter Code',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'transactionId',
        title: 'Transaction ID',
        width: 80,
    }, {
        dataIndex: 'accountMSISDN',
        title: 'Customer',
        width: 80,
    }, {
        dataIndex: 'destinationAccountAlias',
        title: 'Driver Alias',
        width: 80,
        // colSpan: privilege.isTaxi? 1 : 0
    }, {
        dataIndex: 'destinationAccountName',
        title: 'Account Name',
        width: 80,
        // colSpan: privilege.isTaxi? 1 : 0
    }, {
        dataIndex: 'originalAmount',
        title: 'Amount (SGD)',
        width: 80,
        render: text => {
            return parseFloat(text).toFixed(2);
        }
    }, {
        dataIndex: 'destinationCommission1',
        title: 'MDR (SGD)',
        width: 80,
        render: text => {
            return parseFloat(text).toFixed(2);
        }
        // colSpan: !privilege.isTaxi? (privilege.userPrivilege===5? 1 : 0):0
    }, {
        dataIndex: 'transactionType',
        title: 'Transaction Type',
        width: 80,
    }, {
        dataIndex: 'originalTransactionId',
        title: privilege && privilege.isTaxi ? "Original Transaction ID" : "Reference Transaction ID",
        width: 80,
    }
];

const refundColums = [
    {
        dataIndex: 'requestDate',
        title: 'Date and Time',
        width: 80,
        render: text => {
            return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss");
        }
    }, {
        dataIndex: 'accountToOwnerName',
        title: 'Area Name',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'accountToName',
        title: 'Outlet Name',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'counterAlias',
        title: 'Counter Code',
        width: 80,
        // colSpan: privilege.isTaxi? 0 : 1
    }, {
        dataIndex: 'accountFrom',
        title: 'Customer',
        width: 80,
    }, {
        dataIndex: 'amount',
        title: 'Amount (SGD)',
        width: 80,
        render: text => {
            return parseFloat(text).toFixed(2);
        }
    }, {
        dataIndex: 'salesOrderNumberId',
        title: "Transaction ID",
        width: 80,
    }

]


class ViewTrans extends Component {
    constructor(props) {
        privilege = sessionManager.getPrivilege();
        super(props)
        this.state = {
            total: 0,
            merchantList: [],
            selectedMerchant:'',
            data: [],
            pageNum: 1,
            pageSize: 10,
            tabData: "0",
            loading: false,
            selectedRowKeys: [],
            searchType: "0",
            searchKey: "",
            fileType: ".xls",
            totalTranCount: "",
            voidTranCount: "",
            columns: [],
            startDate: "",
            endDate: "",
            isOpenModal: false
        }
    }

    openModal = () => {
        this.setState({ isOpenModal: true })
    }

    closeModal = () => {
        this.setState({ isOpenModal: false })
    }

    handleChangeTab = (key) => {
        console.log('handleChangeTab:'+key);
        let col;
        if (key !== "2") {
            col = columns.filter(item => {
                if (privilege) {
                    if (key === "0") {
                        if (privilege.isTaxi) {
                            return !(item.title == "Area Name" || item.title == "Outlet Name" || item.title == "Counter Code" || item.title == "MDR (SGD)")
                        } else {

                            let falseFlag = !(item.title === "Driver Alias" || item.title === "Account Name")
                            if (privilege.userPrivilege !== 5) {
                                return !(item.title === "MDR (SGD)" || !falseFlag)
                            }
                            return falseFlag;
                        }
                    } else if (key === "1") {
                        if (!((privilege.userPrivilege === 5 && !privilege.isTaxi) || (privilege.userPrivilege === 2 && privilege.isTaxi && !isSMRTNonCFOUser))) {
                            return false;
                        } else {
                            return item.title === "Date and Time" || item.title === "Transaction ID" || item.title === "Amount (SGD)"
                        }
                    }
                }else{
                    //admin
                    return true;
                }
            })
        } else {
            col = refundColums;
        }
        this.setState({ tabData: key, pageNum: 1, columns: col, total:0, data:[]}, () => {
            this.handleSearch()
        });
    };

    doExport = () => {
        let { searchType, searchKey, fileType, startDate, endDate } = this.state;
        var detailId = sessionManager.getMerchantId();
        var { userPrivilege, isTaxi } = sessionManager.getPrivilege()
        var data = { searchType, searchKey, fileType, startDate, endDate, detailId, userPrivilege, isTaxi }
        downloadFile(api.doExport, JSON.stringify(data));
    }


    handleChangePage = (current, pageSize) => {
        this.setState({ pageNum: current, pageSize: pageSize }, () => {
            this.handleSearch()
        })
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    handleSearch = () => {
        this.setState({ loading: true })
        let { searchType, searchKey, tabData, pageSize, pageNum, startDate, endDate,selectedMerchant } = this.state;
        let { userPrivilege, isTaxi } = sessionManager.getPrivilege()
        let detailId = sessionManager.getMerchantId();
        let searchData = { pageNum, pageSize, searchType, searchKey, tabData, startDate, endDate, userPrivilege, isTaxi, detailId, merchantName:selectedMerchant };
        var _this = this;

        if(sessionManager.getUserRole() !== '3'){
            //super admin
            post(api.getAdminTransactionList, searchData).then(response => {
                var { pageList } = response;
                var { total, currentPage, pageSize, rows } = pageList
                _this.setState({
                    pageNum: currentPage,
                    pageSize: pageSize,
                    total: total,
                    data: rows,
                    loading: false,
                })
                if (tabData === "0") {
                    _this.setState({
                        totalTranCount: total,
                        voidTranCount: 0,
                    })
                }
            }).catch(function (error) {
                error = error.toString();
                notification['error']({
                    message: error,
                });
                console.log(error)
                _this.setState({
                    loading: false
                })
            })

        }else{
            post(api.getTransactionList, searchData).then(function (response) {
                var { pageList, todayTotalTxnNumber, refundedTransaction } = response;
                var { total, currentPage, pageSize, rows } = pageList
                _this.setState({
                    pageNum: currentPage,
                    pageSize: pageSize,
                    total: total,
                    data: rows,
                    loading: false,
                })
                if (tabData === "0") {
                    _this.setState({
                        totalTranCount: todayTotalTxnNumber,
                        voidTranCount: refundedTransaction,
                    })
                }
            }).catch(function (error) {
                error = error.toString();
                notification['error']({
                    message: error,
                });
                console.log(error)
                _this.setState({
                    loading: false
                })
            })
        }

    }

    handleSubmit = () => {
        this.setState({ pageNum: 1 }, () => {
            this.handleSearch()
        })
    }

    handleChangeSearchKey = (event) => {
        this.setState({ searchKey: event.target.value })
    }

    handleSelectMerchant = (value) => {
        console.log('handleSelectMerchant:'+ value);
        this.setState({ selectedMerchant: value });
    }

    handleSelectSearchType = (value) => {
        this.setState({ searchType: value })
    }

    handleSelectFileType = (value) => {
        this.setState({ fileType: value })
    }

    handleRowSelection = () => {
        /*let { selectedRowKeys, tabData } = this.state;
        if ((tabData === "0" && privilege && privilege.userPrivilege >= 2 && privilege.userPrivilege !== 5 && !privilege.isTaxi) || (tabData === "2" && privilege.userPrivilege >= 2 && !privilege.isTaxi)) {
            return {
                selectedRowKeys,
                onChange: this.onSelectChange,
            };
        }*/
        return false;
    }

    componentWillMount() {
        this.handleChangeTab("0")
    }

    componentDidMount() {
        this.setState({ tabData: "0" });
        //load merchant dropdown list
        let searchData = { parentId: 0, dictType: 'MERCHANT_DROP_DOWN'};
        post(api.queryDictList, searchData).then(response => {
            this.setState({
                merchantList: response,
            })
        })
    }


    render() {

        const { selectedRowKeys, tabData, startDate, endDate, data, pageNum, total, loading, searchType, searchKey, fileType, columns, totalTranCount, voidTranCount, merchantList,selectedMerchant } = this.state;
        const { userPrivilege, isTaxi } = sessionManager.getPrivilege();
        let merchantDropdownUI = merchantList.map((item,index) => {
            return <Select.Option key={index} value={item.dictName}>{item.dictCode}</Select.Option>;
        })

        return (

            <div style={{ width: "100%" }}>

                {/* //TODO:content */}

                <Descriptions column={2}>
                    <Descriptions.Item labelStyle={{ fontSize: '22px' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px' }} label="Total Transactions">{totalTranCount}</Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontSize: '22px' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px' }} label="Void Transactions">{voidTranCount}</Descriptions.Item>
                </Descriptions>

                <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", marginBottom: "10px", padding: "20px" }}>
                    <Form
                        layout="inline"
                    >

                        {sessionManager.getUserRole()!== '3' && 
                            <Form.Item>
                            <Select placeholder="Select Merchant" style={{ width: '150px' }} value={selectedMerchant} onSelect={this.handleSelectMerchant}  >
                                <Select.Option value={''}>{'-Select Merchant-'}</Select.Option>
                                {merchantDropdownUI}
                            </Select>
                            </Form.Item>
                        }
                        
                        <Form.Item>
                            <Select style={{ width: '150px' }} value={searchType} onSelect={this.handleSelectSearchType}  >
                                <Select.Option value="0">By Transaction ID</Select.Option>
                                <Select.Option value="1">By Customer</Select.Option>
                                {isTaxi && <Select.Option value="2">By Driver ID</Select.Option>}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{ marginLeft: "-17px" }}>
                            <Input style={{ width: '180px' }} value={searchKey} onChange={this.handleChangeSearchKey} />
                        </Form.Item>
                        
                        <Form.Item label="Start date: ">
                            <DatePicker disabledDate={current => endDate && current.diff(endDate) >= 0} onChange={(date, dateString) => this.setState({ startDate: date })} />
                        </Form.Item>
                        <Form.Item label="End date: ">
                            <DatePicker disabledDate={current => startDate && current.diff(startDate) <= 0} onChange={(date, dateString) => this.setState({ endDate: date })} />
                        </Form.Item>
                        <Form.Item>
                            <Button type='primary' icon={<SearchOutlined />} onClick={this.handleSubmit}>Search</Button>
                        </Form.Item>
                    </Form>
                </div>


                <div style={{ marginTop: "20px" }}>
                    <Tabs style={{ marginBottom: "-17px", border: '1px solid #ffffff', borderBottom: '0px' }} size="large" defaultActiveKey="0" onChange={this.handleChangeTab}>
                        <TabPane tab="Transactions" key="0" />
                        {privilege && ((privilege.userPrivilege === 5 && !privilege.isTaxi) || (privilege.userPrivilege === 2 && privilege.isTaxi && !isSMRTNonCFOUser)) &&
                            <TabPane tab="Cash Out Transactions" key="1" />}
                        {privilege && privilege.userPrivilege >= 2 && !privilege.isTaxi &&
                            <TabPane tab="Void Requests" key="2" />}
                    </Tabs>

                    <Table
                        rowSelection={this.handleRowSelection()}
                        scrollToFirstRowOnChange={true}
                        scroll={{ x: '100%', y: 360 }}
                        columns={columns}
                        rowKey={record => {
                            if (tabData !== "2") {
                                return record.transactionId;
                            } else {
                                return record.requestId;
                            }
                        }}
                        dataSource={data}
                        pagination={false}
                        loading={loading} />
                    <Pagination style={{ marginTop: '5px' }} current={pageNum} showSizeChanger={true} total={total} onChange={this.handleChangePage} />

                </div>
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between", height: "30px" }}>
                    {tabData != "1" && <div>
                        <Button style={{display:'none'}} type="primary" disabled>Cancel</Button>
                        <Button onClick={this.openModal} type="primary" disabled style={{ marginLeft: "15px", display:'none' }}>Void</Button>
                    </div>}
                    {(tabData === "0") &&
                        <Form
                            layout="inline"
                        >
                            <Form.Item label="Export as:">
                                <Select style={{ width: '150px' }} value={fileType} onSelect={this.handleSelectFileType} >
                                    <Select.Option value=".xls">.xls</Select.Option>
                                    <Select.Option value=".csv">.csv</Select.Option>
                                    <Select.Option value=".pdf">.pdf</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" onClick={this.doExport} icon={<CloudDownloadOutlined />} >Export</Button>
                            </Form.Item>
                        </Form>}
                </div>
                {this.state.isOpenModal && <ValidPassword selectedRowKeys={selectedRowKeys} isOpenModal={this.state.isOpenModal} closeModal={this.closeModal} />}
            </div>
        )
    }
}

export default ViewTrans;